import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// route components
import { DebugPageComponent } from './components/debug-page.component';
import { DynamicFormComponent } from './components/dynamic-form.component';
import { ProcessingComponent } from './components/processing.component';
import { ProcessingExternalComponent } from './components/processing-external.component';
import { DecisionDetailsComponent } from './components/decision-details.component';
import { DemoDecisionComponent } from './components/demo-decision.component';
import { FindApplicationComponent } from './components/find-application.component';
import { DisclosuresComponent } from './components/disclosures.component';
import { DeclarationsComponent } from './components/declarations.component';
import { ErrorBlankApplicationComponent } from './components/error-blank-application.component';
import { ErrorComponent } from 'src/app/components/error.component';
import { MiniPortalComponent } from './components/producer-mini-portal.component';
import { ProducerWelcomeComponent } from './components/producer-welcome.component';
import { ThankYouComponent } from './components/thank-you.component';
import { ErrorPageComponent } from './components/error-page.component';
import { ErrorSessionComponent } from './components/error-session.component';
import { DemoResumeApplicationComponent } from './components/demo-resume-app.component';
import { DemoWelcomeComponent } from './components/demo-welcome.component';
import { ProducerDemoResumeApplicationComponent } from './components/producer-demo-resume-app.component';

// services
import {ErrorPageService} from './services/error-page.service';

// declare base segment
const baseSegment = 'express';
const ownerDeclarationTitle= 'Owner Declaration';
const ownerDeclarationsTitle= 'Owner Declarations';
// define routes array
let routes: Routes = [
  // {
  //   path: `${baseSegment}/illustration-start`,
  //   component: DynamicFormComponent,
  //   data: {
  //     next: `${baseSegment}/proposed-insured`,
  //     blockName: 'IllustrationStart',
  //     blockHeading: 'Illustration Start',
  //     menuLabel: 'Illustation Start',
  //     blockConditionalClause: 'IllustrationPrePop',
  //     isProgressRoute: true
  //   },
  //   canActivate: [ErrorPageService],
  // },
  {
    path: `${baseSegment}/proposed-insured`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/policy-owner`,
      blockName: 'SECTIONAProposedInsured',
      blockHeading: 'Proposed Insured',
      menuLabel: 'Proposed Insured',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/policy-owner`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/partnership-statement`,
      blockName: 'SECTIONBPolicyOwner',
      blockHeading: 'Policy Owner',
      menuLabel: 'Policy Owner',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/partnership-statement`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/trust-certification`,
      blockName: 'PartnershipStatement',
      blockHeading: 'Partnership Statement',
      menuLabel: 'Partnership Statement',
      blockConditionalClause: 'PartnershipStatementCompound',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  // {
  //   path: `${baseSegment}/trust-certification`,
  //   component: DynamicFormComponent,
  //   data: {
  //     next: `${baseSegment}/beneficiary-information`,
  //     blockName: 'TrustCertification',
  //     blockHeading: 'Trust Certification',
  //     menuLabel: 'Trust Certification',
  //     blockConditionalClause: 'TrustCertificationInfo',
  //     isProgressRoute: true
  //   },
  //   canActivate: [ErrorPageService],
  // },
  {
    path: `${baseSegment}/beneficiary-information`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/coverage-details`,
      blockName: 'SECTIONCBeneficiaryInformation',
      blockHeading: 'Beneficiary Information',
      menuLabel: 'Beneficiary Information',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/coverage-details`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/ltc-personal-worksheet`,
      blockName: 'SECTIONDCoverageDetails',
      blockHeading: 'Coverage Details',
      menuLabel: 'Coverage Details',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/ltc-personal-worksheet`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/pre-authorized-payment`, 
      blockName: 'LTCRPersonalWorksheet',
      blockHeading: 'LTCR Personal Worksheet',
      menuLabel: 'LTC Personal Worksheet',
      blockConditionalClause: 'LTCRPersonalWorksheet',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/pre-authorized-payment`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/critical-illness`,
      blockName: 'RequestforPreAuthorizedPaymentPlan',
      blockHeading: 'Request for Pre-Authorized Payment Plan',
      menuLabel: 'Pre-Auth Payment',
      blockConditionalClause: 'PAC',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/critical-illness`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/proceeds-allocation`,
      blockName: 'CriticalIllness',
      blockHeading: 'Critical Illness Benefit Rider Supplement',
      menuLabel: 'Critical Illness Rider',
      blockConditionalClause: 'CriticalIllness',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/proceeds-allocation`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/vul-fund-allocation`,
      blockName: 'IULPremandSegmentProceedsAllocations',
      blockHeading: 'Indexed UL Premium and Segment Proceeds Allocation Instructions',
      menuLabel: 'IUL Allocations',
      blockConditionalClause: 'IULPremiumAllocations',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/vul-fund-allocation`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-cost-benefit-pa`,
      blockName: 'VULFundAllocation',
      blockHeading: 'Variable Life Fund Allocation',
      menuLabel: 'VUL Allocations',
      blockConditionalClause: 'VULFundAllocation',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-cost-benefit-pa`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-cost-benefit-me`,
      blockName: 'SupplementCostBenefitPA',
      blockHeading: 'Preliminary Statement of Policy Cost',
      menuLabel: 'Statement Policy Cost',
      blockConditionalClause: 'CostBenefitPACompound',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-cost-benefit-me`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/illustration-certification`,
      blockName: 'SupplementCostBenefitME',
      blockHeading: 'Preliminary Statement of Policy Cost',
      menuLabel: 'Statement Policy Cost',
      blockConditionalClause: 'CostBenefitCompoundME',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/illustration-certification`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/purpose-funding-information`,
      blockName: 'IllustrationCertification',
      blockHeading: 'Life Insurance Illustration Certification',
      menuLabel: 'Illustration',
      blockConditionalClause: 'IllustrationShown',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/purpose-funding-information`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/existing-replacement-pending`,
      blockName: 'SECTIONEPurposeFundingInformation',
      blockHeading: 'Purpose and Funding Information',
      menuLabel: 'Purpose & Funding',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/existing-replacement-pending`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/temporary-life-insurance`,
      blockName: 'SECTIONFExistingReplacementPendingInsuranceInformation',
      blockHeading: 'Existing, Replacing or Pending Insurance',
      menuLabel: 'Existing Insurance',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/temporary-life-insurance`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/juvenile-insurance`,
      blockName: 'SECTIONJTemporaryLifeInsuranceAgreementApplication',
      blockHeading: 'Temporary Life Insurance Agreement Application',
      menuLabel: 'Temporary Insurance',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/juvenile-insurance`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-financial-business`,
      blockName: 'SECTIONIJuvenileInsurance',
      blockHeading: 'Juvenile Insurance',
      menuLabel: 'Juvenile Insurance',
      blockConditionalClause: 'Juvenile',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  
    {
    path: `${baseSegment}/supplement-financial-business`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/taxpayer-identification`,
      blockName: 'FinancialSupplementforBusinessInsurance',
      blockHeading: 'Financial Supplement for Business Insurance',
      menuLabel: 'Business Financial Supplement',
      blockConditionalClause: 'BusinessFinancials',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
    {
    path: `${baseSegment}/taxpayer-identification`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-financial-personal`,
      blockName: 'TIN',
      blockHeading: 'Request For Taxpayer Identification Number and Certification',
      menuLabel: 'Taxpayer ID ',
      blockConditionalClause: 'TINCompound',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-financial-personal`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/personal-information`,
      blockName: 'SupplementFinancialPersonal',
      blockHeading: 'Financial Supplement for Personal Insurance',
      menuLabel: 'Personal Financial Supplement',
      blockConditionalClause: 'PersonalFinancial',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
    },
  {
    path: `${baseSegment}/personal-information`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/lifestyle-information`,
      blockName: 'SECTIONGPersonalInformation',
      blockHeading: 'Personal Information',
      menuLabel: 'Personal Information',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/lifestyle-information`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-avocation`,
      blockName: 'SECTIONHLifestyleInformation',
      blockHeading: 'Lifestyle Information',
      menuLabel: 'Lifestyle Information',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-avocation`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-aviation`,
      blockName: 'SupplementAvocation',
      blockHeading: 'Avocation Questionnaire',
      menuLabel: 'Avocation Questionnaire',
      blockConditionalClause: 'Avocation',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-aviation`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/part2-general-information`,
      blockName: 'SupplementAviation',
      blockHeading: 'Aviation Questionnaire',
      menuLabel: 'Aviation Questionnaire',
      blockConditionalClause: 'AviationSupplement',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/part2-general-information`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/part2-medications`,
      blockName: 'Part2SECTIONAGeneralInformation',
      blockHeading: 'Medical Supplement: General Information',
      menuLabel: 'Medical Overview',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/part2-medications`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/part2-medical-conditions`,
      blockName: 'Part2SECTIONBMedications',
      blockHeading: 'Medical Supplement: Medications',
      menuLabel: 'Medications',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/part2-medical-conditions`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/part2-medical-conditions-details`,
      blockName: 'Part2SECTIONCMedicalConditions',
      blockHeading: 'Medical Supplement: Medical Conditions',
      menuLabel: 'Medical Conditions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/part2-medical-conditions-details`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/part2-medical-diagnostic`,
      blockName: 'Part2SECTIONCMedicalConditions2',
      blockHeading: 'Medical Supplement: Medical Conditions',
      menuLabel: 'Medical Condition Details',
      blockConditionalClause: 'MedicalConditionDetails',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/part2-medical-diagnostic`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/part2-personal-information`,
      blockName: 'Part2SECTIONDMedicalDiagnostic',
      blockHeading: 'Medical Supplement: Medical Conditions and Diagnostic Tests',
      menuLabel: 'Medical Diagnostics',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/part2-personal-information`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-alcohol-and-drug`,
      blockName: 'Part2SECTIONEPersonalInformation',
      blockHeading: 'Medical Supplement: Personal Information',
      menuLabel: 'Medical Personal Info',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-alcohol-and-drug`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-long-term-care`,
      blockName: 'SupplementAlcoholAndDrug',
      blockHeading: 'Alcohol and Drug Questionnaire',
      menuLabel: 'Alcohol and Drugs',
      blockConditionalClause: 'AlcoholorDrug',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-long-term-care`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-long-term-care-ca`,
      blockName: `SupplementLTC`,
      blockHeading: 'Long-Term Care Rider Supplement',
      menuLabel: 'LTC Rider Supplement',
      blockConditionalClause: 'ApplicationSupplementLTC',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-long-term-care-ca`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/supplement-dbchr`,
      blockName: `SupplementLTCCA`,
      blockHeading: 'Long-Term Care Rider Supplement',
      menuLabel: 'LTC Rider Supplement',
      blockConditionalClause: 'ApplicationSupplementLTCCA',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/supplement-dbchr`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/pre-authorized-payment-plan`,
      blockName: `SupplementDBCHR`,
      blockHeading: 'Chronic Illness Rider Supplement',
      menuLabel: 'Chronic Illness Rider Supplement',
      blockConditionalClause: 'ApplicationSupplementDBCHR',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/pre-authorized-payment-plan`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/disclosures`,
      blockName: `RequestforPreAuthorizedPaymentPlanInsured`,
      blockHeading: 'Request for Pre-Authorized Payment Plan',
      menuLabel: 'Pre-Auth Payment',
      blockConditionalClause: 'BankingInfo',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/disclosures`,
    component: DisclosuresComponent,
    data: {
      next: `${baseSegment}/declarations`,
      blockName: `Disclosures`,
      blockHeading: 'Disclosures',
      menuLabel: 'Disclosures',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsInsured`,
      blockHeading: 'Proposed Insured Declaration',
      menuLabel: 'Insured Declarations',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  //owner declarations
  {
    path: `${baseSegment}/declarations-owner-A`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerA`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerASignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-B`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerB`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerBSignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-C`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerC`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerCSignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-D`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerD`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerDSignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-E`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerE`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerESignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-F`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerF`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerFSignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-G`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerG`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerGSignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-H`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerH`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerHSignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-I`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerI`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerISignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-owner-J`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/agent-report`,
      blockName: `DeclarationsOwnerJ`,
      blockHeading: ownerDeclarationTitle,
      menuLabel:  ownerDeclarationsTitle,
      blockConditionalClause: 'OwnerJSignatureOwnerInstructions',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  //end of owner decs
  {
    path: `${baseSegment}/agent-report`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/transmittal`,
      blockName: 'AgentReport',
      blockHeading: 'Agent Report',
      menuLabel: 'Agent Report',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/transmittal`,
    component: DynamicFormComponent,
    data: {
      next: `${baseSegment}/declarations-agent`,
      blockName: `TransmittalBlock`,
      blockHeading: 'Agent Disclosures',
      menuLabel: 'Transmittal',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  {
    path: `${baseSegment}/declarations-agent`,
    component: DeclarationsComponent,
    data: {
      next: `${baseSegment}/processing`,
      blockName: `DeclarationsAgent`,
      blockHeading: 'Agent Disclosures',
      menuLabel: 'Agent Declarations',
      isProgressRoute: true
    },
    canActivate: [ErrorPageService],
  },
  { path: `${baseSegment}/thank-you`, component: ThankYouComponent, data: { blockName: `InsuredAppCompleted`, isProgressRoute: true },
    canActivate: [ErrorPageService]},
  { path: `${baseSegment}/processing`, component: ProcessingComponent, data: { blockName: 'Processing', isProgressRoute: true },
    canActivate: [ErrorPageService]},
  { path: `${baseSegment}/processing-external-application`, component: ProcessingExternalComponent, data: { blockName: 'ProcessingExternal', isProgressRoute: true },
    canActivate: [ErrorPageService]},
  { path: `${baseSegment}/decision-details`, component: DecisionDetailsComponent, data: { blockName: 'Decision', isProgressRoute: true  }, canActivate: [ErrorPageService]},
  { path: `${baseSegment}/demo-decision`, component: DemoDecisionComponent, data: { blockName: 'Decision', isProgressRoute: true  }, canActivate: [ErrorPageService]},
  { path: `${baseSegment}/find-application`, component: FindApplicationComponent, data: { disableTimer: true }},
  { path: `${baseSegment}/demo-resume-application`, component: DemoResumeApplicationComponent, data: { disableTimer: true }},
  { path: `${baseSegment}/producer-demo-resume-application`, component: ProducerDemoResumeApplicationComponent, data: { disableTimer: true }},
  { path: `${baseSegment}/financial-professional`, component: MiniPortalComponent},
  { path: `${baseSegment}/error`, component: ErrorComponent, data: { disableTimer: true }},
  { path: `${baseSegment}/error-blank-application`, component: ErrorBlankApplicationComponent, data: { disableTimer: true }},
  { path: `${baseSegment}/error-session`, component: ErrorSessionComponent, data: { disableTimer: true } },
  { path: `${baseSegment}/welcome`, component: ProducerWelcomeComponent},
  { path: `${baseSegment}/demo-welcome`, component: DemoWelcomeComponent},
  { path: `${baseSegment}/error-page`, component: ErrorPageComponent, data: { disableTimer: true } },
  { path: `${baseSegment}`, component: DebugPageComponent },
  { path: '', redirectTo: `${baseSegment}`, pathMatch: 'full' },
  { path: '**', component: DebugPageComponent }

];

// update index
routes = routes.map((value, index) => {
  if (value.data && value.data.isProgressRoute) {
    value.data.routeIdx = index;
  }

  return value;
});

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      enableTracing: false,
      scrollPositionRestoration: 'enabled'
    } // debugging purposes only
  )],
  exports: [RouterModule]
})

export class AppRoutingModule {}
